import React, { Suspense, useEffect } from 'react';
import { useNavigate, useLocation, Routes as RouterRoutes, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AuthRoute from '../auth-route/AuthRoute';
import { ToggleFeatureConsumer } from '../../toggleFeature';
import '../../utils/styles/main.css';
import FallBackLoader from '../../components/FallBackLoader';
import { BUILD } from '../../utils/config';
import { enableNewOnboardingUi } from '../../redux/actions/onboarding/new-onboarding-action';
import { storeNiumForexUser } from '../../redux/actions/nium-forex/nium-forex-action';
import {
  ACKNOWLEDGED_URL,
  ADD_PAYEE_URL,
  CHANGE_PASSWORD_URL,
  DASHBOARD_URL,
  AMAZE_URL,
  AMAZE_ACKNOWLEDGE_URL,
  BASE_URL,
  FEEDBACK_URL,
  FEEDBACK_URL_V2,
  FORGOT_PASSWORD_URL,
  HISTORY_URL,
  INSTAPOINTS_URL,
  INVITE_BY_URL,
  MOBILE_VERIFICATION_URL,
  EMAIL_VERIFICATION_URL,
  PAYEE_LIST_URL,
  REFERRAL_URL,
  RFI_URL,
  SIGNIN_URL,
  SIGNUP_PIN_VERIFY_URL,
  SIGNUP_URL,
  SUBSCRIPTION_URL,
  TRANSFER_MONEY_URL,
  USER_PROFILE_URL,
  USER_REGISTRATION_URL,
  MY_INFO_RESGISTRATION_URL,
  MY_INFO_CALL_BACK_URL,
  MULTIPLE_TRANSACTION_URL,
  JUMIO,
  JUMIO_SUCCESS,
  JUMIO_ERROR,
  MANAGE_PAYMENT_OPTION_URL,
  RESET_PASSWORD,
  SME_BLACKLISTED_PATHS,
  POST_LOGOUT_URL,
  NEW_SME_URL,
  HELP_CENTER,
  CORPORATE,
  NIUM_FOREX_URL_SEND_MONEY,
  EU_REGION,
  MY_KYC,
  NIUM_FOREX_URL,
  INDIVIDUAL,
  NIUM_FOREX_ESIGN_IN_CALLBACK_URL,
  NIUM_FOREX_AADHAR_CALLBACK_URL,
  NIUM_FOREX_VIDEO_KYC_CALLBACK_URL,
  CONSENT_PERMISSION_URL,
  RFI_EKYC_URL,
  APP_ONLY_CORRIDOOR_WELCOME_URL,
  GOOGLE_RECAPTCHA_PUBLIC_URL
} from '../../utils/constants';

import SignInUp from '../../screens/authentication/Authentication';
import ReferEarn from '../../screens/refer-earn/index';
import { enableChatBot } from '../../redux/actions/common/common-action';
import styled from 'styled-components';
import { ModalFactory } from '../modal/modal';
import ServiceUnavailable from '../indiaServiceUnavailable/ServiceUnavailable';
import { NF_ALLOWED_ROUTES, CALLBACKS_URL } from '../../screens/nium-forex/root/screenConstants';
import { getUserTier } from '../../redux/actions/user-status/user-status-action';
import { isUniformReferralCountry } from '../../screens/referrals-instapoints/utils';
import { isAppOnlyCorridor } from '../../screens/app-only-corridor-welcome/utils';

const EkycLandingPage = React.lazy(() =>
  import('../../screens/ekyc-rfi').then((module) => ({ default: module.EkycLandingPage }))
);
const AckWrapper = React.lazy(() => import('../../screens/acknowledgement/AckWrapper'));
const MobileVerificationScreen = React.lazy(() =>
  import('../../screens/mobile-verification/MobileVerificationScreen')
);
const AppOnlyCorridorWelcomeScreen = React.lazy(() =>
  import('../../screens/app-only-corridor-welcome')
);
const ConsentPermissionScreen = React.lazy(() => import('../../screens/consent-permission'));
const AddOrEditPayee = React.lazy(() =>
  import('../../screens/nium-forex/forex-pages/recipient/add-payee-list/AddOrEditPayee')
);
const UserProfile = React.lazy(() => import('../../screens/user-profile/UserProfile'));
const FeedBack = React.lazy(() => import('../../screens/feedback/FeedBack'));
const FeedBackV2 = React.lazy(() => import('../../screens/feedbackV2/FeedBack'));
const Amaze = React.lazy(() => import('../../screens/amaze'));
const AcknowledgeSG = React.lazy(() => import('../../screens/amaze-acknowledge/reviewAckScreen'));
const AmazeAcknowledge = React.lazy(() => import('../../screens/amaze-acknowledge'));
const Dashboardwrapper = React.lazy(() => import('../../screens/dashboard/dashboard-wrapper'));
const FormFlowStructure = React.lazy(() => import('../../screens/user-flow/UserFlow'));
const InstaPoints = React.lazy(() => import('../../screens/referrals-instapoints/InstaPoints'));
const Rewards = React.lazy(() => import('../../screens/referrals-instapoints/Rewards'));
const RFIWrapper = React.lazy(() => import('../../screens/RFI/Rfi'));
const MyTieredKyc = React.lazy(() =>
  import(
    '../../screens/user-flow/individual/individual-documents-upload/individualDocumentUploadMy'
  )
);
const Subscription = React.lazy(() => import('../../screens/subscription/Subscription'));
const NotFound = React.lazy(() => import('../../components/not-found/NotFound'));
const MyInfoRegistration = React.lazy(() =>
  import('../../screens/my-info-registration/MyInfoRegistration')
);
const MyInfoRegistrationSG = React.lazy(() =>
  import('../../screens/my-info-registration/MyInfoRegistrationSG')
);
const JumioVerification = React.lazy(() => import('../../screens/jumio-flow'));
const JumioSuccess = React.lazy(() => import('../../screens/jumio-flow/jumio-success'));
const JumioError = React.lazy(() => import('../../screens/jumio-flow/jumio-error'));
const NiumForex = React.lazy(() => import('../../screens/niumForex/NiumForex'));
const NiumForexRootComponent = React.lazy(() => import('../../screens/nium-forex/root'));

const AddEditBeneficiary = React.lazy(() => import('../../screens/beneficiary-flow'));
const TransactionHistory = React.lazy(() =>
  import('../../screens/transaction-history/TransactionHistory')
);
const PayeeList = React.lazy(() => import('../../screens/payee-list/PayeeList'));

const StyleGuide = React.lazy(() => import('../shared-components/style-guide'));
const ManagePayment = React.lazy(() => import('../../screens/manage-payment/ManagePayment'));

const PostLogout = React.lazy(() => import('../../screens/post-logout/PostLogout'));
const MigrationNotice = React.lazy(() => import('../../screens/migration-notice/MigrationNotice'));
const HelpCenterLandingPage = React.lazy(() =>
  import('../../screens/help-center/HelpCenterLandingPage')
);

const GoogleReCaptchaPage = React.lazy(() => import('../../screens/google-captcha/Captcha'));

const MainContainer = styled.div`
  min-height: ${(props) =>
    props.headerHeight && `calc(100vh - ${props.headerHeight}px) !important`};
  height: ${(props) => props.headerHeight && `calc(100vh - ${props.headerHeight}px) !important`};
`;

const FormFlowWithToggleFeat = () => (
  <ToggleFeatureConsumer>
    <FormFlowStructure />
  </ToggleFeatureConsumer>
);

const handleServiceUnavailable = async () => {
  return await ModalFactory.builder(
    (onClose) => <ServiceUnavailable onClose={onClose} />,
    'send-money-bene-modal insta-modal center-modal',
    true
  );
};

function RoutesComponent(props) {
  const { bgColor, sgMyInfo } = props.featureState;
  const { email, enableNewOnboardingUi, storeNiumForexUser, getUserTier } = props;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    (async () => {
      if (props.countryCode === 'IN' && props.accountType === INDIVIDUAL) {
        storeNiumForexUser(true);
        const currentURL = window.location.href;
        if (currentURL.includes('help-center')) {
          navigate(NIUM_FOREX_URL);
          return;
        }
        if (
          !NF_ALLOWED_ROUTES.includes(location.pathname) &&
          !(
            location.pathname.includes(CALLBACKS_URL.forexAadharCallbackURL) ||
            location.pathname.includes(CALLBACKS_URL.eSignInCallbackUrl) ||
            location.pathname.includes(CALLBACKS_URL.forexVideoCallbackURL)
          )
        ) {
          navigate(NIUM_FOREX_URL);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.countryCode]);

  useEffect(() => {
    const { nonHardMigratedSMEFlow, countryCode, hard_sme_migrated, accountType, isNiumForexUser } =
      props;

    if (hard_sme_migrated && SME_BLACKLISTED_PATHS.includes(window.location.pathname)) {
      if (window.location.pathname !== HISTORY_URL) navigate(NEW_SME_URL);
    }
    if (
      !hard_sme_migrated &&
      nonHardMigratedSMEFlow &&
      SME_BLACKLISTED_PATHS.includes(window.location.pathname)
    ) {
      const { isFeatureEnabled, data } = nonHardMigratedSMEFlow;
      if (isFeatureEnabled && data.includes(countryCode)) navigate(DASHBOARD_URL);
    }
    if (props.countryCode === 'IN' && props.accountType === 'INDIVIDUAL') {
      (async () => {
        !isNiumForexUser && storeNiumForexUser(true);
        const isManualRegistrationFlow = window.location.href.includes('user/registration');
        const pagesToRenderServiceUnavailable =
          window.location.href.includes('dashboard') ||
          window.location.href.includes('aadhaar-kyc') ||
          isManualRegistrationFlow;

        if (!isNiumForexUser && pagesToRenderServiceUnavailable) await handleServiceUnavailable();
      })();
    }
    if (window.location.pathname !== HELP_CENTER) {
      props.enableChatBot();
    }

    if (
      accountType === CORPORATE &&
      (window.location.pathname === HELP_CENTER ||
        window.location.pathname === INSTAPOINTS_URL ||
        window.location.pathname === REFERRAL_URL)
    ) {
      navigate(DASHBOARD_URL);
    }

    if (countryCode === 'AU' || countryCode === 'MY' || EU_REGION.includes(countryCode)) {
      enableNewOnboardingUi(true);
    }
    if (isAppOnlyCorridor(accountType, countryCode)) {
      navigate(APP_ONLY_CORRIDOOR_WELCOME_URL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.countryCode, window.location.pathname]);

  useEffect(() => {
    const { zE: zenDesk } = window;
    if (zenDesk) {
      zenDesk('messenger', 'close');
    }
  }, []);

  useEffect(() => {
    if (email && props.userStatus === 'APPROVED' && props.accountType === INDIVIDUAL) {
      getUserTier();
    }
    // eslint-disable-next-line
  }, [email, props.userStatus, props.accountType]);

  return (
    <Suspense fallback={<FallBackLoader />}>
      <MainContainer className={bgColor === 'white' ? 'main-content' : 'main-content-bg'}>
        <Suspense fallback={<FallBackLoader />}>
          <RouterRoutes>
            <Route
              path={SIGNIN_URL}
              element={
                <AuthRoute featureState={props.featureState} component={SignInUp} onlyUnAuth />
              }
            />
            <Route
              path={RESET_PASSWORD}
              element={
                <AuthRoute featureState={props.featureState} component={SignInUp} onlyUnAuth />
              }
            />
            <Route
              path={SIGNUP_URL}
              element={
                <AuthRoute featureState={props.featureState} component={SignInUp} onlyUnAuth />
              }
            />
            <Route
              path={SIGNUP_PIN_VERIFY_URL}
              element={<SignInUp featureState={props.featureState} />}
            />
            <Route
              path={FORGOT_PASSWORD_URL}
              element={
                <AuthRoute featureState={props.featureState} component={SignInUp} onlyUnAuth />
              }
            />
            <Route
              path={CHANGE_PASSWORD_URL}
              element={
                <AuthRoute featureState={props.featureState} component={SignInUp} onlyUnAuth />
              }
            />
            <Route
              path={MOBILE_VERIFICATION_URL}
              element={
                <AuthRoute featureState={props.featureState} component={MobileVerificationScreen} />
              }
            />
            <Route
              path={EMAIL_VERIFICATION_URL}
              element={
                <AuthRoute featureState={props.featureState} component={MobileVerificationScreen} />
              }
            />
            <Route
              path={CONSENT_PERMISSION_URL}
              element={
                <AuthRoute featureState={props.featureState} component={ConsentPermissionScreen} />
              }
            />
            <Route
              path={APP_ONLY_CORRIDOOR_WELCOME_URL}
              element={
                <AuthRoute
                  featureState={props.featureState}
                  component={AppOnlyCorridorWelcomeScreen}
                />
              }
            />
            <Route
              path={USER_PROFILE_URL}
              element={<AuthRoute featureState={props.featureState} component={UserProfile} />}
            />
            <Route
              path={FEEDBACK_URL_V2}
              element={<FeedBackV2 featureState={props.featureState} />}
            />
            <Route
              path={FEEDBACK_URL}
              element={<AuthRoute featureState={props.featureState} component={FeedBack} />}
            />
            <Route
              path={PAYEE_LIST_URL}
              element={<AuthRoute featureState={props.featureState} component={PayeeList} />}
            />
            <Route
              path={DASHBOARD_URL}
              element={<AuthRoute featureState={props.featureState} component={Dashboardwrapper} />}
            />
            <Route
              path={AMAZE_URL}
              element={<AuthRoute featureState={props.featureState} component={Amaze} />}
            />
            <Route
              path={AMAZE_ACKNOWLEDGE_URL}
              element={
                <AuthRoute
                  data={props}
                  featureState={props.featureState}
                  component={props.countryCode === 'SG' ? AcknowledgeSG : AmazeAcknowledge}
                />
              }
            />
            <Route
              path={RFI_URL}
              element={<AuthRoute featureState={props.featureState} component={RFIWrapper} />}
            />
            <Route
              path={RFI_EKYC_URL}
              element={<AuthRoute featureState={props.featureState} component={EkycLandingPage} />}
            />
            <Route
              path={MY_KYC}
              element={<AuthRoute featureState={props.featureState} component={MyTieredKyc} />}
            />
            <Route
              path={INVITE_BY_URL}
              element={
                <AuthRoute featureState={props.featureState} component={SignInUp} onlyUnAuth />
              }
            />
            <Route
              path={SUBSCRIPTION_URL}
              element={<AuthRoute featureState={props.featureState} component={Subscription} />}
            />
            <Route
              path={MANAGE_PAYMENT_OPTION_URL}
              element={<AuthRoute featureState={props.featureState} component={ManagePayment} />}
            />
            <Route
              path={ADD_PAYEE_URL}
              element={
                <AuthRoute
                  featureState={props.featureState}
                  component={props.isNiumForexUser ? AddOrEditPayee : AddEditBeneficiary}
                />
              }
            />
            <Route
              path={REFERRAL_URL}
              element={<AuthRoute featureState={props.featureState} component={ReferEarn} />}
            />
            <Route
              path={INSTAPOINTS_URL}
              element={
                <AuthRoute
                  featureState={props.featureState}
                  component={isUniformReferralCountry(props.countryCode) ? Rewards : InstaPoints}
                />
              }
            />
            <Route
              path={HISTORY_URL}
              element={
                <AuthRoute featureState={props.featureState} component={TransactionHistory} />
              }
            />
            <Route
              path={TRANSFER_MONEY_URL}
              element={
                <AuthRoute featureState={props.featureState} component={FormFlowWithToggleFeat} />
              }
            />
            <Route
              path={USER_REGISTRATION_URL}
              element={
                <AuthRoute featureState={props.featureState} component={FormFlowWithToggleFeat} />
              }
            />
            <Route
              path={MY_INFO_CALL_BACK_URL}
              element={
                <AuthRoute
                  featureState={props.featureState}
                  component={sgMyInfo ? MyInfoRegistrationSG : MyInfoRegistration}
                />
              }
            />
            <Route
              path={ACKNOWLEDGED_URL}
              element={<AuthRoute featureState={props.featureState} component={AckWrapper} />}
            />
            <Route
              path={MY_INFO_RESGISTRATION_URL}
              element={
                <AuthRoute
                  featureState={props.featureState}
                  component={sgMyInfo ? MyInfoRegistrationSG : MyInfoRegistration}
                />
              }
            />
            <Route
              path={MULTIPLE_TRANSACTION_URL}
              element={
                <AuthRoute featureState={props.featureState} component={FormFlowWithToggleFeat} />
              }
            />
            <Route
              path={POST_LOGOUT_URL}
              element={
                <AuthRoute featureState={props.featureState} component={PostLogout} onlyUnAuth />
              }
            />
            <Route path={NIUM_FOREX_URL_SEND_MONEY} element={<NiumForex />} />
            <Route
              path={GOOGLE_RECAPTCHA_PUBLIC_URL}
              element={<GoogleReCaptchaPage shouldShowCaptcha />}
            />
            <Route
              path={NIUM_FOREX_ESIGN_IN_CALLBACK_URL}
              element={<AuthRoute component={NiumForexRootComponent} />}
            />
            <Route
              path={NIUM_FOREX_AADHAR_CALLBACK_URL}
              element={<AuthRoute component={NiumForexRootComponent} />}
            />
            <Route
              path={NIUM_FOREX_VIDEO_KYC_CALLBACK_URL}
              element={<AuthRoute component={NiumForexRootComponent} />}
            />
            <Route
              path={NIUM_FOREX_URL}
              element={<AuthRoute component={NiumForexRootComponent} />}
            />
            <Route path={NEW_SME_URL} element={<AuthRoute component={MigrationNotice} />} />
            <Route path={HELP_CENTER} element={<AuthRoute component={HelpCenterLandingPage} />} />
            <Route path={JUMIO} element={<AuthRoute component={JumioVerification} />} />
            <Route path={JUMIO_SUCCESS} element={<JumioSuccess />} />
            <Route path={JUMIO_ERROR} element={<JumioError />} />
            {BUILD !== 'prod' && (
              <Route path={`${BASE_URL}/shared-component`} element={<StyleGuide />} />
            )}
            <Route path="*" element={<NotFound featureState={props.featureState} />} />
          </RouterRoutes>
        </Suspense>
      </MainContainer>
    </Suspense>
  );
}

RoutesComponent.propTypes = {
  featureState: PropTypes.object,
  countryCode: PropTypes.string,
  hard_sme_migrated: PropTypes.any,
  enableChatBot: PropTypes.func,
  headerRef: PropTypes.object,
  accountType: PropTypes.string,
  nonHardMigratedSMEFlow: PropTypes.object,
  status: PropTypes.string,
  email: PropTypes.string,
  enableNewOnboardingUi: PropTypes.func,
  storeNiumForexUser: PropTypes.func,
  isNiumForexUser: PropTypes.bool,
  userStatus: PropTypes.string,
  getUserTier: PropTypes.func
};

const mapStateToProps = (reduxState) => {
  const {
    rootReducer: {
      userStatusReducer: { account_type: accountType, nonHardMigratedSMEFlow, status, email },
      userSessionReducer: {
        user_session: { user_status: userStatus }
      },
      niumForexReducer: { isNiumForexUser }
    }
  } = reduxState;

  return {
    accountType,
    nonHardMigratedSMEFlow,
    status,
    email,
    isNiumForexUser,
    userStatus
  };
};

const AppRoutes = RoutesComponent;
export default connect(mapStateToProps, {
  enableChatBot,
  enableNewOnboardingUi,
  storeNiumForexUser,
  getUserTier
})(AppRoutes);
